<template>
  <div class="container-small">
    <div class="inner">
      <button class="toggleBtn" @click="toggleContent" v-if="!isVisible">
        {{ isVisible ? "Skjul vudering" : "Gi din vudering" }}
      </button>
      <div v-if="isVisible">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false
    };
  },
  methods: {
    toggleContent() {
      this.isVisible = !this.isVisible;
    }
  }
};
</script>

<style scoped>
.toggleBtn {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #2f4286;
  background: white;
  font-size: 16px;
  line-height: 19px;
  font-weight: bold;
  color: #2f4286;
}
</style>
